import React, {useEffect, useState} from 'react';
import { loadStripe } from "@stripe/stripe-js"
import { Elements } from "@stripe/react-stripe-js"
import CheckoutForm from '../form/CheckoutForm'

import _ from "lodash";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY, { locale: 'en' })

const CardPayment = () => {

    const [clientSecret, setClientSecret] = useState("");
    const [error, setError] = useState("");

    useEffect(() => {

        fetch(`${process.env.REACT_APP_API_URL}/setup-intent/`,{
            headers: {'Accept': 'application/json', 'Content-Type':'application/x-www-form-urlencoded'},
            credentials: 'include',
            method: 'POST',
        })
            .then(function (res) {
                if(res.status === 200){
                    res.json().then(function(data){
                        if(data.client_secret){
                            setClientSecret(data.client_secret)
                        }
                    })
                }
                else{
                    setError('Internal Server Error')
                    console.log('Internal Server Error');
                }
            })
            .catch(err => {
                setError('Internal Server Error')
                console.log(err);
            });
    }, [])

    const appearance = {
        theme: 'light',
        labels: 'none',
        variables: {
            fontFamily: 'system-ui',
            colorIcon: '#CF2363',
            colorPrimary: '#22211E',
            fontWeightNormal: 500,
            colorWarning: '#CF2363',
            fontSmooth: "always",
            colorDanger: '#CF2363',
        },
        rules: {
            '.FormGroup': {
                backgroundColor: "#212121"
            },
            '.Label': {
                color: "gray"
            }
        }
    };

    const options = {
        clientSecret,
        appearance,
    };

    return(
        <>
            {
                !_.isEmpty(clientSecret) &&
                <div className="card-component">
                    <div className="card-content">
                        <Elements stripe={stripePromise} options={options}><CheckoutForm/></Elements>
                    </div>
                </div>
            }
            {
                _.isEmpty(clientSecret) &&
                <>
                    {
                        _.isEmpty(error) &&
                        <div className="loader"></div>
                    }
                    {
                        !_.isEmpty(error) &&
                        <div>
                            <h3>{error}</h3>
                        </div>
                    }
                </>
            }
        </>
    )
};

export default CardPayment;